import { Skeleton } from './Skeleton';
import { SkeletonCircle } from './SkeletonCircle';

/**
 * Skeleton for trip card in grid layouts.
 * Used in My Trips, Favorites, and Profile pages.
 */
export const TripCardSkeleton = () => {
  return (
    <div className="flex flex-col group relative bg-surface rounded-3xl p-3 shadow-sm ring-1 ring-gray-900/5">
      <div className="relative w-full">
        <Skeleton className="aspect-[3/2] w-full rounded-2xl" />
      </div>
      <div className="mt-4 px-2 pb-2">
        <div className="flex items-center gap-x-4">
          <SkeletonCircle size="h-10 w-10" />
          <div className="flex flex-col flex-1">
            <Skeleton className="h-6 w-32 mb-1" />
            <Skeleton className="h-4 w-20" />
          </div>
        </div>
      </div>
    </div>
  );
};

/**
 * Skeleton for year divider in trip grids.
 */
export const YearDividerSkeleton = () => {
  return (
    <div className="flex items-center mb-8">
      <Skeleton className="h-9 w-20" />
      <div className="ml-6 flex-1 border-t-2 border-subtle"></div>
    </div>
  );
};

/**
 * Skeleton for trip grid with multiple cards.
 */
export const TripGridSkeleton = ({ count = 3 }: { count?: number }) => {
  return (
    <div className="w-full">
      <div className="mb-16">
        <YearDividerSkeleton />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
          {Array.from({ length: count }).map((_, index) => (
            <TripCardSkeleton key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};
